(function() {
    angular.module("app").controller("ResetVehicleCounterController", ResetVehicleCounterController)

    ResetVehicleCounterController.$inject = [
        "$scope",
        "$uibModalInstance",
        "trackersService",
        "trackerID",
        "onSuccess",
        "onFailure"
    ]

    function ResetVehicleCounterController(
        $scope,
        $uibModalInstance,
        trackersService,
        trackerID,
        onSuccess,
        onFailure
    ){
        "use strict"

        $scope.reset = function( ) {
            $uibModalInstance.close(
                trackersService.resetVehicleCounter(trackerID, onSuccess, onFailure)
            )
        }

       $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
